import React from 'react';
import './TransitionSectionOne.css';

const TransitionSectionOne = ({ theme }) => (
  <div className={`transition-gradientOne theme-${theme}`}></div>
);

export default TransitionSectionOne;
